import React from "react";
import { CiBellOn } from "react-icons/ci";
import PropTypes from "prop-types";
import AlertModal from "./AlertModal/index";
import { dataLayer } from "../../../lib/analytics";

const Alerts = ({
  serviceTypes,
  jobAlert: existingJobAlert,
  isArtistLoggedIn,
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [jobAlert, setJobAlert] = React.useState(existingJobAlert);

  const onCloseModal = () => {
    setModalOpen(false);
    dataLayer.push({
      event: "jobBoardAlertSettingsClose",
    });
  };

  const onOpenModal = () => {
    setModalOpen(true);
    dataLayer.push({
      event: "jobBoardAlertSettingsOpen",
    });
  };

  const ctaText = jobAlert
    ? I18n.t("recycled_inquiries.index.toolbar.notifications.manage_alert")
    : I18n.t("recycled_inquiries.index.toolbar.notifications.create_alert");

  return (
    <>
      <div className="b-toolbar__alerts">
        <button
          type="button"
          onClick={onOpenModal}
          className="b-toolbar__alerts-button"
        >
          <CiBellOn size={18} />
          {ctaText}
        </button>
      </div>
      <AlertModal
        isOpen={modalOpen}
        onClose={onCloseModal}
        serviceTypes={serviceTypes}
        jobAlert={jobAlert}
        setJobAlert={setJobAlert}
        isArtistLoggedIn={isArtistLoggedIn}
      />
    </>
  );
};

Alerts.propTypes = {
  serviceTypes: PropTypes.object.isRequired,
  jobAlert: PropTypes.object,
  isArtistLoggedIn: PropTypes.bool.isRequired,
};

Alerts.defaultProps = {
  jobAlert: null,
};

export default Alerts;
